import React from 'react';
import Select from '@rio-cloud/rio-uikit/lib/es/Select';
import { FormattedMessage } from 'react-intl';
import SemanticVersionInputFormItem from '~/features/base/components/forms/SemanticVersionInputFormItem';
import Tooltip from "@rio-cloud/rio-uikit/lib/es/Tooltip";
import {OverlayTrigger} from "react-bootstrap";
import {useGetAllDeliverablesIds} from '~/features/deliverables/hooks/useDeliverablesIds';
import {DeliverableSearchCriteriaDeliverableTypeEnum} from '~/api/models/deliverable-search-criteria';

const InstalledDeliverablesFormGroup = ({
    deliverables: deliverablesProp,
    values,
    onChange,
    noCompatibilitySeparator
}) => {
    const fetchedDeliverables = useGetAllDeliverablesIds([DeliverableSearchCriteriaDeliverableTypeEnum.BUNDLE, DeliverableSearchCriteriaDeliverableTypeEnum.APP, DeliverableSearchCriteriaDeliverableTypeEnum.CM4G, DeliverableSearchCriteriaDeliverableTypeEnum.DISTRO]);
    const deliverables = deliverablesProp || fetchedDeliverables;

    const emptyRow = {
        deliverableId: '',
        deliverableType: '',
        versionRange: {
            minValue: {
                major: 0,
                minor: 0,
                patch: 0
            },
            maxValue: {
                major: 0,
                minor: 0,
                patch: 0
            }
        }
    };
    const defaultValues = [emptyRow];

    const optionsWithSelection = deliverables?.map((app) => {
        return {
            label: `${app.id} (${app.type})`,
            type: app.type,
            deliverableId: app.id,
            id: `${app.id}${app.type}`
        };
    });

    const onFieldsChange = (newValue, index) => {
        if (index != undefined) {
            const currentValues = (Array.isArray(values) && values.length > 0) ? values : [emptyRow];
            let appList = [...currentValues];
            appList[index] = { ...currentValues[index], ...newValue || '' };
            onChange(appList);
        }
    };

    const onDeliverableChange = (newValue, index) => {
        if (index != undefined) {
            const deliverable = { ['deliverableType']: newValue.type, ['deliverableId']: newValue.deliverableId };
            onFieldsChange(deliverable, index);
        }
    };
    const onVersionRangeChange = (field, newValue, index) => {
        if (index != undefined) {
            const currentValues = (Array.isArray(values) && values.length > 0) ? values : [emptyRow];
            const range = { ...currentValues[index]?.versionRange, [field]: newValue };
            onFieldsChange({['versionRange']: range}, index);
        }
    };

    const onAddDeliverableFilterFormGroup = () => {
        const currentValues = (Array.isArray(values) && values.length > 0) ? values : [emptyRow];
        onChange(currentValues.concat(defaultValues));
    };

    const onDeleteDeliverableFilterFormGroup = (index) => {
        const currentValues = (Array.isArray(values) && values.length > 0) ? values : [emptyRow];
        if (currentValues.length === 1) {
            onChange(undefined);
            return;
        }
        let list = [...currentValues];
        list.splice(index, 1);
        onChange(list);
    };

    return <div className={''}>
    <div className={''}>
        <label className='control-label margin-bottom-10 '>
            <FormattedMessage id='intl-msg:vehicleInstalledDeliverables'/>
        </label>
    </div>
            {(() => {
                const displayValues = (Array.isArray(values) && values.length > 0) ? values : [emptyRow];
                return displayValues.map((value, index) => (
                    <div key={index} className=''>
                        <div className={'bg-white padding-15'}>
                            <div className={'display-flex'}>
                                <div className=' gap-20'>
                                <div className='padding-right-10'>
                                    <label className='control-label'>
                                        <FormattedMessage id='intl-msg:deliverableId'/>
                                    </label>
                                    <Select
                                        useFilter
                                        useClear
                                        placeholder='Enter deliverable id'
                                        options={optionsWithSelection}
                                        value={[value && `${value.deliverableId}${value.deliverableType}`]}
                                        onChange={(value) => {
                                            onDeliverableChange(value, index);
                                        }}
                                    />
                                </div>
                                <div className='display-flex gap-10 margin-top-10'>
                                    <SemanticVersionInputFormItem
                                        label='intl-msg:minValue'
                                        value={value?.versionRange?.minValue}
                                        onChange={(value) => {
                                            onVersionRangeChange('minValue', value, index);
                                        }}
                                        classNameInputField='col-xs-3 col-sm-3 col-md-3'
                                        classNameClearButton='col-xs-3 col-sm-3 col-md-2'
                                    />
                                    <SemanticVersionInputFormItem
                                        label='intl-msg:maxValue'
                                        value={value?.versionRange?.maxValue}
                                        onChange={(value) => {
                                            onVersionRangeChange('maxValue', value, index);
                                        }}
                                        classNameInputField='col-xs-3 col-sm-3 col-md-3'
                                        classNameClearButton='col-xs-3 col-sm-3 col-md-2'
                                    />
                                </div>
                            </div>
                                <div className={'display-flex justify-content-end align-items-end'}>
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={
                                            <Tooltip id='tooltip-delete' className='top-right'>
                                                <FormattedMessage id='intl-msg:delete'/>
                                            </Tooltip>
                                        }
                                    >
                                    <button
                                        type='button'
                                        className='btn btn-link padding-5 text-size-14'
                                        onClick={() => {
                                            onDeleteDeliverableFilterFormGroup(index);
                                        }}
                                        title='Delete'
                                    >
                                        <span className='rioglyph rioglyph-trash'/>
                                    </button>
                                        </OverlayTrigger>

                                </div>
                            </div>
                        </div>
                    </div>
                ));
            })()}
            <div className='display-flex justify-content-end'>
                <OverlayTrigger
                    placement='top'
                    overlay={
                        <Tooltip id='tooltip-add' className='top-right'>
                            <FormattedMessage id='intl-msg:changeOperation.add'/>
                        </Tooltip>
                    }
                >
                <button
                    type='button'
                    className='padding-10 btn btn-primary'
                    onClick={onAddDeliverableFilterFormGroup}
                >
                    <span className='rioglyph rioglyph-plus text-size-14 margin-0'/>
                </button>
                </OverlayTrigger>
            </div>
    </div>;
}

export default InstalledDeliverablesFormGroup;
